<script>
  import pwaInstallHandler from "pwa-install-handler";
  let modalInstall = false;
  pwaInstallHandler.addListener((canInstall) => {
    setTimeout(() => {
      if (localStorage.getItem("install")) {
      } else {
        modalInstall = canInstall;
      }
    }, 1500);
  });
  function hideModalInstall() {
    localStorage.setItem("install", true);
    modalInstall = false;
  }
  import SOffline from "s-offline";
  const handleNetworkChange = ({ detail }) => {};
  import { fade } from "svelte/transition";
  import Error404 from "./pages/Error404.svelte";
  import Background from "./components/Background.svelte";
  import ProductDetail from "./pages/ProductDetail.svelte";
  import Footer from "./components/Footer.svelte";
  import Alert from "./components/Alert.svelte";
  import Login from "./pages/Login.svelte";
  import Daftar from "./pages/Daftar.svelte";
  import Forget from "./pages/Forget.svelte";
  import Dashboard from "./pages/Dashboard.svelte";
  import Tagihan from "./pages/Tagihan.svelte";
  import Transaksi from "./pages/Transaksi.svelte";
  import Kabar from "./pages/Kabar.svelte";
  import Checkout from "./pages/Checkout.svelte";
  import Keranjang from "./pages/Keranjang.svelte";
  import Market from "./pages/Toko/Market.svelte";
  import Hotspot from "./pages/Hotspot.svelte";
  import HotspotLogin from "./pages/HotspotLogin.svelte";
  import Pelayanan from "./pages/Pelayanan.svelte";
  import Kartu from "./pages/Kartu.svelte";
  import Riwayat from "./pages/Riwayat.svelte";
  import Akun from "./pages/Akun.svelte";
  import UpdateProfile from "./pages/UpdateProfile.svelte";
  import UpdateEmail from "./pages/UpdateEmail.svelte";
  import UpdateNomor from "./pages/UpdateNomor.svelte";
  import UpdateAlamat from "./pages/UpdateAlamat.svelte";
  import UpdatePass from "./pages/UpdatePass.svelte";
  import Points from "./pages/Points.svelte";
  import Mapgeo from "./pages/Mapgeo.svelte";
  import Tokoku from "./pages/Toko/Tokoku.svelte";
  import Ngirim from "./pages/Ngirim/Ngirim.svelte";
  import TokokuEdit from "./pages/Toko/TokokuEdit.svelte";
  import Add from "./pages/Toko/Add.svelte";
  import Kp from "./pages/Rule/Kp.svelte";
  import Sk from "./pages/Rule/Sk.svelte";
  import Pencarian from "./pages/Pencarian.svelte";
  import Splash from "./pages/Splash.svelte";
  import { Router, Route, NotFound, redirect } from "./pager";

  import axios from "axios";
  import { notif, session } from "./components/js/notif.js";

  let notify;
  const unsubscribe_notif = notif.subscribe((value) => {
    notify = value;
  });
  let loadingLine = false;

  let sessions;
  const unsubscribe_session = session.subscribe((value) => {
    sessions = value;
  });
  let settings;
  let _token = localStorage.getItem("t");

  if (_token) {
    if (!sessions.data) {
      loadingLine = true;
      axios
        .get("https://api.dekatan.com/sipade/get/scan/0", {
          params: {
            authorization: _token,
          },
        })
        .then(function (response) {
          settings = {
            url: "https://api.dekatan.com",
            token: _token,
            loggedin: true,
            data: response.data,
          };
          UpdatePusData(response.data);
          UpdateSession(settings);
          loadingLine = false;
        })
        .catch(function (error) {
          if (error.response.status == 401) {
            UpdateSession(null);
            localStorage.removeItem("t");
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: "Anda mungkin harus login kembali",
                color: "orange",
              },
            ];
          } else {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: "Anda belum terhubung dengan baik",
                color: "orange",
              },
            ];
          }
          loadingLine = false;
        });
    }
  }
  if (sessions) {
    settings = sessions;
  } else {
    settings = {
      url: "https://api.dekatan.com",
      loggedin: false,
    };

    UpdateSession(settings);
  }

  load_notif();
  let interval_notif = setInterval(() => {
    load_notif();
  }, 50000);
  function load_notif() {
    if (_token) {
      axios
        .get(settings.url + "/sipade/notif", {
          params: {
            authorization: _token,
          },
        })
        .then(function (response) {
          notif.update((n) => response.data.notif);
        })
        .catch(function (error) {
          clearInterval(interval_notif);
        });
    }
  }

  //alert
  let alert = [];

  //alert - welcome
  if (!sessionStorage["welcome_message"]) {
    alert = [
      ...alert,
      {
        title: "Dekatan",
        message: "Hallo, Selamat datang, semoga hari anda menyenangkan...",
        color: "green",
      },
    ];
    setTimeout(() => {
      alert = [];
    }, 5000);
  }
  sessionStorage["welcome_message"] = false;
  const guard = (ctx, next) => {
    loadingLine = true;
    if (_token) {
      if (settings.loggedin == true) {
        axios
          .get(settings.url + "/sipade/get/scan/0", {
            params: {
              authorization: settings.token,
            },
          })
          .then(function (response) {
            settings = {
              url: "https://api.dekatan.com",
              token: settings.token,
              loggedin: true,
              data: response.data,
            };

            UpdateSession(settings);
            next();
            loadingLine = false;
          })
          .catch(function (error) {
            if (error.response.status == 401) {
              localStorage.removeItem("t");
              redirect("/login");
              window.location.reload();
            }
            loadingLine = false;
          });
      } else {
        settings = {
          url: "https://api.dekatan.com",
          token: _token,
          loggedin: true,
        };
        axios
          .get(settings.url + "/sipade/get/scan/0", {
            params: {
              authorization: _token,
            },
          })
          .then(function (response) {
            settings = {
              url: "https://api.dekatan.com",
              token: settings.token,
              loggedin: true,
              data: response.data,
            };

            UpdateSession(settings);
            next();
            loadingLine = false;
          })
          .catch(function (error) {
            if (error.response.status == 401) {
              localStorage.removeItem("t");
              redirect("/login");
              loadingLine = false;
            }
          });
      }
    } else {
      redirect("/splash");
      loadingLine = false;
    }
  };
  function UpdateSession(set) {
    session.update((n) => set);
  }
  function UpdatePusData(set) {
    webpushr("attributes", { id_pen: set.pen.id, area: set.pen.area });
  }
</script>

{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<SOffline
  pingUrl="https://api.dekatan.com"
  on:detectedCondition={handleNetworkChange}
>
  <div slot="online" class="online">
    <span class="hidden">Anda Online</span>
  </div>
  <div slot="offline" class="offline">
    <div
      class="fixed top-0 left-0 right-0 z-30 flex items-center justify-center w-screen h-screen bg-red-700 bg-opacity-75"
    >
      <div
        id="modal-Offline"
        class="w-10/12 p-6 font-normal text-gray-700 bg-white border-2 border-orange-400 rounded-lg shadow-lg lg:w-3/12"
        style="height: 200px;"
      >
        <h2 class="mb-2 text-xl">Kamu Offline..🤕</h2>
        <p class="my-4 text-sm">
          Cek koneksi data internet/wifi kamu, agar dapat terhubung kembali
          dengan Dekatan
        </p>
        <a
          href="./"
          on:click|preventDefault={() => window.location.reload()}
          id="ReloadConnection"
          style="display:inline-block;"
          class="w-full p-2 text-center text-orange-800 bg-orange-300 rounded-lg shadow-lg focus:bg-gray-200 focus:outline-none hover:bg-orange-200"
          >Coba Lagi</a
        >
      </div>
    </div>
  </div>
</SOffline>

{#if modalInstall}
  <div
    transition:fade={{ duration: 400 }}
    class="fixed top-0 left-0 right-0 z-10 flex items-center justify-center w-screen h-screen bg-gray-700 bg-opacity-75"
  >
    <div
      id="modal-install"
      class="w-10/12 p-6 font-normal text-gray-700 bg-white rounded-lg lg:w-3/12"
      style="height: 190px;"
    >
      <h2 class="mb-2 text-xl">Install Aja...</h2>
      <p class="my-4 text-sm">
        Install Dekatan gak perlu download, klik tombol pasang sekarang
      </p>
      <button
        id="installButton"
        style="display:inline-block;"
        on:click={() => pwaInstallHandler.install()}
        on:click={() => hideModalInstall()}
        class="w-full p-2 text-green-800 bg-green-300 rounded-lg shadow-lg focus:bg-gray-200 focus:outline-none hover:bg-green-200"
        >Pasang Sekarang</button
      >
      <button
        on:click={() => hideModalInstall()}
        class="flex items-center justify-center w-6 h-6 p-2 mx-auto my-3 text-sm text-red-700 bg-gray-100 rounded-full shadow focus:outline-none"
        >x</button
      >
    </div>
  </div>
{/if}
<Background />
<Router>
  <Route path="/" middleware={[guard]}>
    <Dashboard />
    <Footer />
  </Route>

  <Route path="/splash">
    <Splash />
  </Route>

  <Route path="/login">
    <Login />
  </Route>

  <Route path="/daftar">
    <Daftar />
  </Route>

  <Route path="/forget">
    <Forget />
  </Route>

  <Route path="/tagihan" middleware={[guard]}>
    <Tagihan />
    <Footer />
  </Route>

  <Route path="/akun/transaksi" middleware={[guard]}>
    <Transaksi />
    <Footer />
  </Route>

  <Route path="/akun/transaksi/:status" let:params middleware={[guard]}>
    <Transaksi data={params} />
    <Footer />
  </Route>

  <Route path="/akun/profile" middleware={[guard]}>
    <UpdateProfile />
    <Footer />
  </Route>

  <Route path="/akun/email" middleware={[guard]}>
    <UpdateEmail />
    <Footer />
  </Route>

  <Route path="/akun/password" middleware={[guard]}>
    <UpdatePass />
    <Footer />
  </Route>

  <Route path="/akun/nomor" middleware={[guard]}>
    <UpdateNomor />
    <Footer />
  </Route>

  <Route path="/akun/alamat" middleware={[guard]}>
    <UpdateAlamat />
    <Footer />
  </Route>

  <Route path="/akun" middleware={[guard]}>
    <Akun />
    <Footer />
  </Route>

  <Route path="/pelayanan" middleware={[guard]}>
    <Pelayanan />
    <Footer />
  </Route>

  <Route path="/kartu" middleware={[guard]}>
    <Kartu />
    <Footer />
  </Route>

  <Route path="/riwayat" middleware={[guard]}>
    <Riwayat />
    <Footer />
  </Route>

  <Route path="/points" middleware={[guard]}>
    <Points />
    <Footer />
  </Route>

  <!--NGIRIM-->
  <Route path="/ngirim" middleware={[guard]}>
    <Ngirim />
    <Footer />
  </Route>

  <Route path="/ngirim/:status" let:params middleware={[guard]}>
    <Ngirim data={params} />
    <Footer />
  </Route>

  <!--TOKOKU-->
  <Route path="/tokoku" middleware={[guard]}>
    <Tokoku />
    <Footer />
  </Route>

  <Route path="/tokoku/transaksi" middleware={[guard]}>
    <Tokoku />
    <Footer />
  </Route>

  <Route path="/tokoku/transaksi/:status" let:params middleware={[guard]}>
    <Tokoku data={params} />
    <Footer />
  </Route>

  <Route path="/tokoku/edit" middleware={[guard]}>
    <TokokuEdit />
    <Footer />
  </Route>

  <Route path="/tokoku/add" middleware={[guard]}>
    <Add />
    <Footer />
  </Route>

  <Route path="/tokoku/update/:alias/:id" let:params middleware={[guard]}>
    <Add data={params} />
    <Footer />
  </Route>

  <!--BELANJA DOMAIN-->
  <Route path="/belanja/:domain" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/cari/:domain/q/:q" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/:domain/q/:q" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/:domain/q/:q/page/:page" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/:domain/page/:page" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/:domain/c/:category" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/:domain/c/:category/q/:q" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/:domain/c/:category/page/:page" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/:domain/c/:category/q/:q/page/:page" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <!--BELANJA-->
  <Route path="/PetaSetempat" middleware={[guard]}>
    <Mapgeo />
    <Footer />
  </Route>

  <Route path="/belanja" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/cari/q/:q" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/q/:q" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/q/:q/page/:page" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/page/:page" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/c/:category" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/c/:category/q/:q" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/c/:category/page/:page" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/c/:category/q/:q/page/:page" let:params>
    <Market data={params} />
    <Footer />
  </Route>

  <Route path="/belanja/p/keranjang" middleware={[guard]}>
    <Keranjang />
    <Footer />
  </Route>

  <Route path="/belanja/p/checkout" middleware={[guard]}>
    <Checkout />
    <Footer />
  </Route>

  <Route path="/product/:alias-:id" let:params>
    <ProductDetail data={params} />
    <Footer />
  </Route>

  <Route path="/pencarian" let:params>
    <Pencarian />
    <Footer />
  </Route>

  <Route path="/p/:alias-:id" let:params>
    <ProductDetail data={params} />
    <Footer />
  </Route>

  <Route path="/hotspot" middleware={[guard]}>
    <Hotspot />
    <Footer />
  </Route>

  <Route path="/hotspot/:id" let:params middleware={[guard]}>
    <HotspotLogin json={params} />
    <Footer />
  </Route>

  <Route path="/privacy">
    <Kp />
    <Footer />
  </Route>

  <Route path="/syarat-ketentuan">
    <Sk />
    <Footer />
  </Route>

  <Route path="/kabar">
    <Kabar />
    <Footer />
  </Route>

  <NotFound>
    <Error404 />

    <Footer />
  </NotFound>
  {#if loadingLine}
    <div
      class="fixed top-0 left-0 right-0 z-50 w-screen h-2 bg-green-500 animate-pulse"
    />
  {/if}
</Router>
